import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const AuthLayout = ({ isSignedIn }) => {

    if (isSignedIn) {
        return <Navigate to="/dashboard" replace />;
    }
    return <Outlet />
}

export default AuthLayout